import React, { useEffect, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";

import Image from "assets/img/default-img.jpg";
import Button from "components/ui/Button";
import { getIcon } from "utils/iconsConfig";
import { ReactComponent as Diamond } from "assets/icons/diamond.svg";
import { ReactComponent as GoldBar } from "assets/icons/small.svg";
import { ReactComponent as Sales } from "assets/sale_icon/sale.svg";
import { ReactComponent as DateIcon } from "assets/icons/date.svg";
import { ReactComponent as Silver } from "assets/icons/sliver.svg";
import { ReactComponent as Bronze } from "assets/icons/brozen.svg";
import { ReactComponent as Gold } from "assets/icons/gold.svg";

const iconMap = {
  silver: <Silver style={{ height: "3vh", width: "1.5vw" }} />,
  bronze: <Bronze style={{ height: "3vh", width: "1.5vw" }} />,
  gold: <Gold style={{ height: "3vh", width: "1.5vw" }} />,
};

const USPCard = ({ data, showBtn, removeFromUsp, addToUsp }) => {
  const [btnTitle, setBtnTitle] = useState("Select");

  useEffect(() => {
    const selectedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];
    const isSelected = selectedDesigns?.some((item) => item.designNumber === data.designNumber);
    setBtnTitle(isSelected ? "Selected" : "Select");
  }, [data]);

  const handleClick = () => {
    if (btnTitle === "Select") {
      setBtnTitle("Selected");
      addToUsp(data);
    } else {
      removeFromUsp(data.designNumber);
      setBtnTitle("Select");
    }
  };

  return (
    <Paper
      sx={{
        bgcolor: "#191818",
        border: "1px solid #fff",
        borderRadius: "0.52vw",
        p: "0.9vw",
        paddingRight: showBtn ? "0.9vw" : "1.5vw",
        display: "flex",
        alignItems: "center",
        width: "28.5vw",
        height: "14.8vw",
        boxShadow: "none",
        position: "relative",
        justifyContent: "space-between",
      }}
    >
      {/* Left Info */}
      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
        {/* Jewel Code with Star */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
          {iconMap[data.designClass.toLowerCase()]}
          <Typography variant="h5" sx={{ color: "#fff", fontSize: "1.3vw", fontFamily: "Karla", fontWeight: 500 }}>
            {data?.designNumber}
          </Typography>
        </Box>

        {/* Diamond Info */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
          <Diamond style={{ height: "3vh", width: "1.5vw" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.8vw !important", fontFamily: "Karla", fontWeight: 400 }}>{data?.diamondInfo}</Typography>
        </Box>

        {/* Weight Info */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
          <GoldBar style={{ height: "3vh", width: "1.5vw" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.8vw", fontFamily: "Karla", fontWeight: 400 }}>{data?.weightInfo}</Typography>
        </Box>

        {/* Bag Count */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
          <Sales style={{ height: "3vh", width: "1.5vw" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.8vw", fontFamily: "Karla", fontWeight: 400 }}>{data?.bagCount}</Typography>
        </Box>

        {/* Date */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
          <DateIcon style={{ height: "3vh", width: "1.5vw" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.8vw", fontFamily: "Karla", fontWeight: 400 }}>{data?.date}</Typography>
        </Box>
      </Box>
      {/* Right Image */}
      <Box
        sx={{
          width: "12vw",
          height: "13vw",
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <img
          src={data.imageUrl ? data.imageUrl : Image}
          alt="jewel"
          style={{
            // width: "12.8vw",
            // height: showBtn ? "25.4vh" : "27.5vh",
            // height: "auto",
            width: "110%",
            height: showBtn ? "95%" : "100%",
            objectFit: "contain",
            borderRadius: "0.3vw",
            background: "#fff",
          }}
        />
      </Box>

      {showBtn && (
        <Button
          variant="contained"
          sx={{
            backgroundColor: btnTitle === "Selected" ? "#50C878" : "#fff",
            color: btnTitle === "Selected" ? "#ffffff !important" : "#50C878 ",
            border: "0.1vw solid #50C878",
            left: "76%",
            top: "78%",
            transform: "translateX(-50%)",
            zIndex: 2,
            textTransform: "none",
            position: "absolute",
            "&:hover": {
              backgroundColor: btnTitle === "Select" ? "#FFFFFF" : "#50C878",
              color: btnTitle === "Select" ? "#50C878" : "#FFFFFF",
            },
            width: "7.1vw !important",
            height: "5.2vh !important",
            padding: "0px 20px !important",
            boxShadow: "0",
            fontFamily: "poppins",
            fontSize: "1.2vw",
          }}
          onClick={handleClick}
        >
          {btnTitle ? btnTitle : "Select"}
        </Button>
      )}
    </Paper>
  );
};

export default USPCard;
